// -----------------------
// <auto-generated>
// Generated using the script normalizrSchemaGenerator.js
// </auto-generated>
// -----------------------
import {
    Category,
    SgmService,
    Subcategory,
} from './SgmSearchApiClient';

export enum ObjectsWithoutIdPropertyEnum {
    Category,
    SgmService,
    Subcategory,
}

export type ObjectsWithoutIdProperty =
    Category
    | SgmService
    | Subcategory;
